import { render, staticRenderFns } from "./ItemEditView.vue?vue&type=template&id=2fbc7df8&"
import script from "./ItemEditView.vue?vue&type=script&lang=js&"
export * from "./ItemEditView.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports